import React, { FC, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Loading from '@/components/skeleton';

import Analytics from '@/components/analytics';
import { useExperiment, useFeatureGate } from '@statsig/react-bindings';
import { getPageEnvByHost } from '@/utils/environment';
import { clientGetStorage, StorageKey } from '@/utils/localStorage';

const Checkout = lazy(() => import('./checkout'));
const CheckoutSuccess = lazy(() => import('./paymentSuccess'));
const InvoiceError = lazy(() => import('./error/invoiceError'));
const PaymentLinkError = lazy(() => import('./error/paymentLinkError'));
const PaymentLinkErrorV2 = lazy(() => import('./error/paymentLinkErrorV2'));
const PayByLinkPrePayment = lazy(() => import('./paybylink/prePayment'));
const PayByLinkPayment = lazy(() => import('./paybylink/payment'));
const PayByLinkPaymentV2 = lazy(() => import('./paybylinkV2/prePayment'));
const PayByLinkPaymentSuccess = lazy(() => import('./paybylink/success'));
const SuccessV2 = lazy(() => import('./paybylinkV2/Success/index'));

const Index: FC = () => {
  const env = getPageEnvByHost();
  const enableOnePageCheckout = clientGetStorage(StorageKey.ONE_PAGE_CHECKOUT) === 'true';
  const enablePblFeV2FF = useFeatureGate('enable-pbl-fe-v2').value;
  const experiment = useExperiment('payment_link_ab_test');
  const enablePblFeV2 = experiment.get('enable-pbl-v2') as boolean;
  const enableV2 = (enablePblFeV2FF && env === 'staging') || enablePblFeV2 || enableOnePageCheckout;
  return (
    <BrowserRouter>
      <Analytics />
      <Suspense fallback={<Loading />}>
        <Switch>
          {/* short payment link url */}
          <Route path="/:code" exact component={enableV2 ? PayByLinkPaymentV2 : PayByLinkPrePayment} />
          {/* original payment link url */}
          <Route path="/pay/link/preview" exact component={enableV2 ? PayByLinkPaymentV2 : PayByLinkPrePayment} />
          <Route
            path="/pay/:region/link/payment/success"
            exact
            component={enableV2 ? SuccessV2 : PayByLinkPaymentSuccess}
          />
          <Route
            path="/pay/:region/link/payment/error"
            exact
            component={enableV2 ? PaymentLinkErrorV2 : PaymentLinkError}
          />
          <Route path="/pay/:region/link/payment/:intentId" exact component={PayByLinkPayment} />
          <Route path="/pay/:region/link/:code" exact component={enableV2 ? PayByLinkPaymentV2 : PayByLinkPrePayment} />
          <Route path="/pay/:region/invoice/success" exact component={CheckoutSuccess} />
          <Route path="/pay/:region/invoice/error" exact component={InvoiceError} />
          <Route path="/pay/:region/invoice/:platform" exact component={Checkout} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Index;
